/*
 * @Description: 获取用户信息
 * @Author: wangbo16
 * @Date: 2021-06-18 15:01:24
 * @LastEditors: xianghai
 * @LastEditTime: 2022-04-18 16:20:00
 */

import React, { useEffect } from 'react';
import {
  Dispatch,
  RootState,
  useRematchState,
  useRematchDispatch
} from '@/store';
import { isInApp } from '@/utils/helpers';
import { QUICK_REPLY } from '@schemas/common';
import user from '@/services/user';
import { DOCTOR_JOBTYPE } from '@/schemas/doctor';
import { useLocation } from 'react-router-dom';

const mapState = (state: RootState) => ({
  isLogin: state.user.isLogin
});

const mapDispatch = (dispatch: Dispatch) => ({
  getUserInfo: dispatch.user.getUserInfo,
  getAuditEntrance: dispatch.user.getAuditEntrance
});

const UserInfo = () => {
  const { isLogin } = useRematchState(mapState);

  const { getUserInfo, getAuditEntrance } = useRematchDispatch(mapDispatch);
  const { pathname } = useLocation();
  useEffect(() => {
    if (!isLogin && isInApp) {
      getUserInfo()
        .then(async (data) => {
          if (
            data?.doctor &&
            data?.quickReply !== QUICK_REPLY.CREATED &&
            data.jobType !== DOCTOR_JOBTYPE.VERIFIED
          ) {
            await user.createQuickReply();
          }
        })
        .catch((e) => {
          //
        });
    }
  }, []);

  useEffect(() => {
    if (isLogin && isInApp && pathname.includes('/doctor-profile')) {
      getAuditEntrance().catch((e) => {
        //
      });
    }
  }, [isLogin, pathname]);

  return <></>;
};

export default UserInfo;
